import { Injectable } from '@angular/core';
import { StorageService } from 'src/app/core/services/global';

@Injectable({
  providedIn: 'root',
})
export class ProfileMessagesService {
  constructor(private storageService: StorageService) {}

  saveSenderId(senderId: string): void {
    this.storageService.setMessageSenderId(senderId);
  }

  getSavedSenderId(): string | null {
    return this.storageService.getMessageSenderId();
  }
}
